import { useEffect, useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { Button } from 'shared/ui/button'
import { Paper } from 'shared/ui/paper'
import { PopularDirectionsUi } from 'shared/ui/popular-directions'

import { allDirectionsExcursionsStore } from '../model'

import s from './styles.module.scss'

export const PopularDirectionsExcursions = observer(() => {
  const { t } = useTranslation()

  const listPopular = allDirectionsExcursionsStore.getAllDirections()

  const navigate = useNavigate()

  const onGoToDetail = (index: number) => {
    const currentItem = listPopular?.[index]

    if (currentItem) {
      navigate({
        pathname: RoutingPaths.excursion.excursionByDirection.path(
          currentItem?.id,
        ),
        search: `name=${currentItem?.name}`,
      })
    }
  }

  const getListPopular = () => {
    allDirectionsExcursionsStore.fetchAllDirections()
  }

  const goToPopularScreen = () => {
    navigate(RoutingPaths.excursion.popular.path())
  }

  useEffect(() => {
    if (!listPopular?.length) {
      getListPopular()
    }
  }, [])

  const preparedListPopular = useMemo(
    () =>
      listPopular?.map((popular) => ({
        id: popular?.id,
        image: popular?.image_url,
        title: popular?.name,
        price: String(popular?.price),
      })),
    [listPopular],
  )

  return (
    <Paper padding={[0]}>
      <div className={s.container}>
        <div className={s.header}>
          <h4 className={s.title}>{t('excursions.popular_title')}</h4>
          <p className={s.subtitle}>
            {t('excursions.popular_title_sub_title')}
          </p>
        </div>

        <div className={s.populars}>
          <PopularDirectionsUi
            goPagePopular={onGoToDetail}
            populars={preparedListPopular}
          />
        </div>

        <div className={s.button}>
          <Button
            variant="grey"
            onClick={goToPopularScreen}
          >
            <span className={s.buttonText}>{t('popular_directions.more')}</span>
          </Button>
        </div>
      </div>
    </Paper>
  )
})
